import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#007AFF",
      "fill-rule": "evenodd",
      d: "M5.392 1.147 3.507 3.032l-.424-.424L5.691 0 8.3 2.608l-.424.424-1.885-1.885v9.162h-.6zM11.387 16H0V4.617h4.194v.6H.599V15.4h10.189V5.216H7.189v-.599h4.198z"
    }, null, -1)
  ]))]))
}
export default { render: render }